import { useSelectSchoolInfo } from '../components/SectionBasicInfo/useSelectSchoolInfo';
import { useBuildInfoContext } from '../context';
import { useGetCategoryFormValue } from '../features/category-form';
import { getBuildPublisherInfoSchema } from '../form/schema/BuildPublisherInfoSchema';
import { getBuildQuizSetBasicInfoSchema } from '../form/schema/BuildQuizSetBasicInfoSchema';
import { getBuildSchoolInfoSchema } from '../form/schema/BuildSchoolInfoSchema';

/**
 *
 * 학교, 출판사, 과목 정보에 대한 유효성 검사
 */
export const useValidateSchoolAndSubjectInfo = () => {
  const buildInfoContext = useBuildInfoContext();
  const { schoolNodes, gradeNodes, semesterNodes } = useSelectSchoolInfo();

  const subjectSchema = getBuildQuizSetBasicInfoSchema().pick({
    subject: true,
  });
  const publisherSchema = getBuildPublisherInfoSchema();
  const schoolSchema = getBuildSchoolInfoSchema({
    schoolNodes,
    gradeNodes,
    semesterNodes,
  });
  const { getCategoryFormValue } = useGetCategoryFormValue();

  const validate = () => {
    const { success, error } = subjectSchema
      .and(publisherSchema)
      .and(schoolSchema)
      .safeParse(getCategoryFormValue(buildInfoContext.schoolInfoTree));

    if (!success) {
      return { success: false, messages: error.errors.map(e => e.message) };
    }

    return { success: true, messages: [] };
  };

  return validate;
};
